import { ChipProps } from '@mui/material';

export const searchFilterScope = ['all', 'any'] as const;
export type SearchFilterScope = (typeof searchFilterScope)[number];

export const SearchFilterOperators = [
  ...searchFilterScope,
  'eq',
  'ge',
  'gt',
  'le',
  'lt',
  'ne',
  'search.in',
  'search.ismatch',
] as const;

export type SearchFilterOperator = (typeof SearchFilterOperators)[number];

export const LogicalOperators = ['and', 'or'] as const;

export type LogicalOperator = (typeof LogicalOperators)[number];

export const LogicalOperatorColorMap: Record<LogicalOperator, ChipProps['color']> = {
  and: 'primary',
  or: 'secondary',
};

const _SearchFilterDataTypes = [
  'boolean',
  'collection',
  'object',
  'value',
  'dateTime',
  'number',
] as const;

export type SearchFilterDataType = (typeof _SearchFilterDataTypes)[number];

type FilterDefinition = {
  canAutocomplete: boolean;
  displayName: string;
  fields: FilterDefinition[];
  isSortable: boolean;
  operators: SearchFilterOperator[];
  propertyName: string;
  tokens: string[];
  type: SearchFilterDataType;
};

export default FilterDefinition;
